export default __webpack_public_path__ + "static/media/bg-explore-education.1a7b4ed4.svg";